module.exports = __webpack_public_path__ + "img/prize-03.978919c0.png";